import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BootstrapModalService } from '../../global/services/bootstrap-modal/bootstrap-modal.service';

@Component({
    selector: 'bootstrap-modal-footer',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="modal-footer row">
            <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </div>
    `
})
export class BootstrapModalFooterComponent implements OnInit, OnDestroy {
    private readonly onDestroy$ = new Subject<void>();

    public footerTemplate: any = null;

    constructor(
        private readonly bootstrapModalService: BootstrapModalService
    ) { }

    ngOnInit(): void {
        this.bootstrapModalService.footerTemplate$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((template) => {
                this.footerTemplate = template;
            });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
